import { faUserFriends, faUsers } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import theme from '@monorepo/shared/src/themes/defaultTheme';
import { ActivityTypes, ASSIGNMENT_STATUSES } from '@monorepo/shared/src/types';
import { Group } from '@monorepo/shared/src/graph/schema-generated-types-educator';
import { GroupTypes } from 'state/providers/AssignmentsProvider/types';

type SizeProp =
  | 'xs'
  | 'lg'
  | 'sm'
  | '1x'
  | '2x'
  | '3x'
  | '4x'
  | '5x'
  | '6x'
  | '7x'
  | '8x'
  | '9x'
  | '10x';

const sortList = [
  GroupTypes.ALL,
  GroupTypes.PREK,
  GroupTypes.EMERGING,
  GroupTypes.DEVELOPING,
] as string[];

const iconColor = {
  Emerging: theme.palette.success.main,
  Developing: theme.palette.warning.main,
  All: theme.palette.link.main,
};

export const iconStyle = (groupName) => ({
  color: iconColor[groupName],
  marginLeft: 5,
});

export const getIcon = (groupName: string, size?: SizeProp | undefined) => {
  const icon = groupName === GroupTypes.ALL ? faUsers : faUserFriends;
  return <FontAwesomeIcon style={iconStyle(groupName)} icon={icon} size={size} />;
};

export const isGroupSelected = (selectedGroups: number[], groupId: number) => {
  return selectedGroups?.includes(groupId);
};

export const isStudentSelected = (selectedStudents: number[], studentId: number | undefined) => {
  if (!studentId) return false;
  return selectedStudents?.includes(studentId);
};

export const determineIfPartialGroupSelected = (
  selectedStudents: number[],
  selectedGroups: number[],
  group: Group
) => {
  if (!group?.groupEnrollments?.length) return;

  const groupSelected = isGroupSelected(selectedGroups, group?.id);
  const studentsSelected = group?.groupEnrollments?.some((s) =>
    isStudentSelected(selectedStudents, s?.studentId)
  );
  return !groupSelected && studentsSelected;
};

export const getSortedValues = (values: string[]) => {
  return values.sort((a, b) => sortList.indexOf(a) - sortList.indexOf(b));
};

export const getSortedGroups = (groups: Group[]) => {
  if (!groups?.length) return [];
  const clonedGroups = [...groups];
  return clonedGroups.sort((a, b) => sortList.indexOf(a.name) - sortList.indexOf(b.name));
};

export const isLetterAssigned = (assignments, letter) => {
  return assignments.some((assignment) => {
    return (
      assignment.character.character === letter &&
      (assignment.groups?.length || assignment.students?.length)
    );
  });
};

export const areAllRequiredAssignmentsComplete = (assignments, letter) => {
  const assignmentActivities = assignments.find(
    (activity) => activity.character.character === letter
  )?.assignmentActivities;

  // filter out optional assignments
  return assignmentActivities
    ?.filter(
      (a) =>
        a?.activity?.activityType?.name !== ActivityTypes.WDT &&
        a?.activity?.activityType?.name !== ActivityTypes.PRACTICE_BOOK
    )
    ?.every((activity) =>
      activity?.attempts?.every((attempt) => attempt.status === ASSIGNMENT_STATUSES.COMPLETE)
    );
};
